import { useMemo } from "react";
import { PAYOUT_COVERAGE } from "../data/payoutCoverage";

/**
 * Filters availableChannels (from useCorridor, keyed by channel type e.g.
 * "mobile_money" / "bank_transfer" / "sepa") down to the channels Blupay
 * actually supports for the given country, per PAYOUT_COVERAGE.
 *
 * Returns [key, channel] entries, same shape as
 * Object.entries(corridor.availableChannels), so it drops in wherever
 * that was previously used directly.
 */
export function useSupportedChannels(
  countryCode,
  availableChannels
) {
  return useMemo(() => {
    const allowedKeys =
      PAYOUT_COVERAGE[
        String(countryCode || "").toUpperCase()
      ] ?? [];

    return Object.entries(
      availableChannels ?? {}
    ).filter(([key]) =>
      allowedKeys.includes(key)
    );
  }, [countryCode, availableChannels]);
}